import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { ConfigurationAPI } from '../apis/ConfigurationAPI';
const ThemeDetailsContext = createContext({
    stateImages: null,
    isLoading: false,
    fetchThemeDetails: async () => { }
});
export const ThemeDetailsProvider = ({ children }) => {
    const [stateImages, setStateImages] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const fetchThemeDetails = useCallback(async () => {
        if (stateImages || isLoading)
            return;
        setIsLoading(true);
        try {
            const bundle = await ConfigurationAPI.getConfigurations('AppConfiguration');
            if (bundle?.resource) {
                for (const config of bundle.resource) {
                    const themeItem = config.items?.find((item) => item.key === 'themeDetails');
                    if (themeItem && typeof themeItem.value === 'object') {
                        const details = themeItem.value;
                        setStateImages(details?.industryDetails?.stateImages ?? null);
                        break;
                    }
                }
            }
        }
        catch (error) {
            console.warn('Failed to fetch theme details:', error);
        }
        finally {
            setIsLoading(false);
        }
    }, [stateImages, isLoading]);
    const contextValue = useMemo(() => ({
        stateImages,
        isLoading,
        fetchThemeDetails
    }), [stateImages, isLoading, fetchThemeDetails]);
    return (_jsx(ThemeDetailsContext.Provider, { value: contextValue, children: children }));
};
/**
 * Hook to access state images and fetch function
 */
export const useThemeDetails = () => useContext(ThemeDetailsContext);
